import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/css/tailwind.css'

// Development helpers
import { showMockDataBanner } from '@/utils/dev'

// Configurar autenticação
import { useAuthStore } from '@/stores/auth'
import { useAuthPersistence } from '@/composables/useAuthPersistence'
import { apiClient } from '@/services/api/base'
import { useAppStore } from '@/stores/app'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Inicializar autenticação e aguardar antes de montar a aplicação
const initApp = async () => {
  // Força modo claro IMEDIATAMENTE antes de qualquer outra coisa
  document.documentElement.classList.remove('dark')
  localStorage.removeItem('darkMode')

  const appStore = useAppStore()
  const authStore = useAuthStore()
  const authPersistence = useAuthPersistence()

  // Inicializa modo claro via store também
  appStore.initDarkMode()

  // Inicializa a autenticação e aguarda o primeiro check
  await authStore.initAuth()

  // Inicia o listener permanente para mudanças de autenticação
  authStore.startAuthListener()

  // Inicia o refresh automático do token
  authStore.startTokenRefresh()

  // Setup da persistência e detecção de atividade
  authPersistence.setup()

  // Configurar callback de refresh do token para requisições API
  apiClient.setTokenRefreshCallback(async () => {
    return await authStore.refreshToken()
  })

  // Redirecionar para login em caso de 403 (acesso negado)
  apiClient.setForbiddenCallback(async () => {
    await authStore.signOut()
    router.push({ path: '/login', query: { reason: 'forbidden' } })
  })

  // Show development banner
  showMockDataBanner()

  // Monta a aplicação após a inicialização da autenticação
  app.mount('#app')
}

// Inicializa a aplicação
initApp().catch(console.error)
